module.exports = __webpack_public_path__ + "img/moneymex_scroll04.4743b7a0.webp";